import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { AppUnlicensedLink } from '../../../components/link'
import { transformRole } from '../../../graphql/schema/queries/helpers/role'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { AgentLanguage } from '../../../components/agent-language'
import { Role } from '@contrast-security-inc/base-types'

const bridgeCss = css`
  color: ${theme.color.turquoise70} !important;
  font-size: 11px;
`

function Wrapper({
  applicationRoles,
  organizationId: organizationID,
  applicationId: applicationID,
  applicationName,
  applicationLanguage,
  hasLicenses,
  archived,
  features,
  refresh
}) {
  return (
    <AppUnlicensedLink
      role={transformRole(applicationRoles) as Role}
      organizationID={organizationID}
      applicationID={applicationID}
      applicationName={applicationName}
      applicationLanguage={AgentLanguage.fromValue(applicationLanguage)}
      hasLicenses={hasLicenses}
      archived={archived}
      features={features}
      refresh={refresh}
      className={bridgeCss}
    />
  )
}

export const reactAppUnlicensedLink = createNgReactBridgeDirective(
  'reactAppUnlicensedLink',
  [],
  Wrapper,
  []
)
